<template>
  <div v-if="breadcrumbs.length > 0" class="inner_breadcrumbs max-characters">
    <span v-for="(b,index) in breadcrumbs" :key="index">

      <router-link v-if="index != breadcrumbs.length - 1" class="single_bc_link"
      :to="b.path">{{b.name}}<span v-if="index != breadcrumbs.length - 1" class="single_bc_icon">›</span>
      </router-link>

      <span class="current" v-if="index == breadcrumbs.length - 1">{{b.name}}</span>
    </span>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  computed:{
    ...mapGetters({breadcrumbs : "breadcrumbs/breadcrumbs"})
  }
};
</script>
<style scoped>
.current{
  color: #000;
  font-size: 16px;
  font-weight: 500;
}
.max-characters{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 30%;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/products/components/ProductBreadcrumbs.vue